import React, { useState } from "react";
import { Link } from "react-router-dom";
import InquiryForm from "../Extra/InquiryForm";
import itdoseImg from "../assests/image/logoitdose.png";
import imglogo from "../assests/image/img/logo/logo-itdose.png";
import ZohoLeadForm from "../Extra/ZohoLeadForm";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [showInquiryForm, setShowInquiryForm] = useState(false);

  const openInquiry = () => setShowInquiryForm(true);
  const closeInquiry = () => setShowInquiryForm(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  console.log({showInquiryForm})
  const toggleSubmenu = (index) => {
    setOpenSubmenu((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      {showInquiryForm && (
        // <InquiryForm onClose={closeInquiry} title={"Inquiry"} />
        <ZohoLeadForm onClose={closeInquiry}/>
      )}
      <div className="navbar-area sticky-nav">
        {/* Mobile Navigation */}
        <div className="mobile-nav">
          <a href="/" className="logo">
            <img src={itdoseImg} className="logo-one" alt="ITDOSE INFOSYSTEMS Logo" loading="lazy" />
            <img src={itdoseImg} className="logo-two" alt="ITDOSE INFOSYSTEMS Logo" loading="lazy" />
          </a>
        </div>
        {/* Desktop Navigation */}
        <div className="main-nav nav-bar-two">
           <div className="container-fluid header-bg">
            <nav className="container-max-2 navbar navbar-expand-md navbar-light">
              <a className="navbar-brand" href="/">
                <img
                  style={{ paddingTop: "12px" }}
                  src={imglogo}
                  alt="ITDOSE INFOSYSTEMS Logo"
                  loading="lazy"
                />
              </a>

              <div
                className="collapse navbar-collapse mean-menu"
                id="navbarSupportedContent"
                style={{ display: "block" }}
              >
                <ul className="navbar-nav m-auto">
                  <li className="nav-item" style={{color:"white"}}>
                    <Link to="/" className="nav-link anim">
                      Home
                    </Link>
                  </li>
                  <li className="nav-item">
                    <a href="#" className="nav-link">
                      About Us <i className="bx bx-plus"></i>
                    </a>
                    <ul className="dropdown-menu">
                      <li className="nav-item">
                        <Link to="/about-the-company" className="nav-link">
                          About The Company
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/vision-mission-and-values"
                          className="nav-link"
                        >
                          Vision, Mission & Values
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/our-team" className="nav-link">
                          Our Team
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item">
                    <a href="#" className="nav-link">
                      Products <i className="bx bx-plus"></i>
                    </a>
                    <ul className="dropdown-menu">
                      <li className="nav-item">
                        <Link
                          to="/hospital-information-and-management-system"
                          className="nav-link"
                        >
                          HOSPEDIA (HIMS)
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/laboratory-information-and-management-system"
                          className="nav-link"
                        >
                          INNOPATH (LIMS)
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item">
                    <Link to="/clients-and-testimonials" className="nav-link">
                      Clients
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/contact-us" className="nav-link">
                      Contact Us
                    </Link>
                  </li>
                </ul>

                <div className="side-nav d-in-line align-items-center">
                  <div className="side-item" style={{paddingTop:"15px"}}>
                    <div className="nav-add-btn">
                      <a
                        href="#"
                        className="nav-menu-btn cta-open"
                        onClick={(e) => {
                          e.preventDefault();
                          openInquiry();
                        }}
                      >
                        Inquire Now <i className="bx bxs-phone"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>{" "}
        <div className="mobile-nav mean-container">
          <div className="mean-bar">
            {/* Menu Icon */}
            {menuOpen ? (
              <>
                <a
                  className="meanmenu-reveal meanclose"
                  onClick={toggleMenu}
                  style={{
                    right: 0,
                    left: "auto",
                    textAlign: "center",
                    textIndent: 0,
                    fontSize: "18px",
                  }}
                >
                  {" "}
                  X
                </a>

                {/* Navigation */}
                <nav className="mean-nav">
                  <ul
                    className="navbar-nav m-auto"
                    style={{ display: menuOpen ? "block" : "none" }}
                  >
                    {/* Home */}
                    <li className="nav-item">
                      <Link to="/" className="nav-link anim">
                        Home
                      </Link>
                    </li>

                    {/* About Us */}
                    <li className="nav-item">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                          marginRight: "20px",
                        }}
                      >
                        <a
                          href="#"
                          className="nav-link"
                          onClick={() => toggleSubmenu(1)}
                        >
                          About Us{" "}
                        </a>{" "}
                        <i
                          className={`bx mt-3 ${
                            openSubmenu === 1 ? "bx-minus" : "bx-plus"
                          }`}
                        ></i>
                      </div>
                      {openSubmenu === 1 && (
                        <ul
                          className="dropdown-menu"
                          style={{ display: "block" }}
                        >
                          <li className="nav-item">
                            <a href="about-the-company" className="nav-link">
                              About The Company
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              href="vision-mission-and-values"
                              className="nav-link"
                            >
                              Vision, Mission & Values
                            </a>
                          </li>
                          <li className="nav-item">
                            <a href="our-team" className="nav-link">
                              Our Team
                            </a>
                          </li>
                        </ul>
                      )}
                    </li>

                    {/* Products */}
                    <li className="nav-item">
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                          marginRight: "20px",
                        }}
                      >
                        <a
                          href="#"
                          className="nav-link"
                          onClick={() => toggleSubmenu(2)}
                        >
                          Products{" "}
                        </a>{" "}
                        <i
                          className={`bx mt-3 ${
                            openSubmenu === 2 ? "bx-minus" : "bx-plus"
                          }`}
                        ></i>
                      </div>
                      {openSubmenu === 2 && (
                        <ul
                          className="dropdown-menu"
                          style={{ display: "block" }}
                        >
                          <li className="nav-item">
                            <a
                              href="hospital-information-and-management-system"
                              className="nav-link"
                            >
                              HOSPEDIA (HIMS)
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              href="laboratory-information-and-management-system"
                              className="nav-link"
                            >
                              INNOPATH (LIMS)
                            </a>
                          </li>
                        </ul>
                      )}
                    </li>

                    {/* Clients */}
                    <li className="nav-item">
                      <Link to="/clients-and-testimonials" className="nav-link">
                        Clients
                      </Link>
                    </li>

                    {/* Contact Us */}
                    <li className="nav-item mean-last">
                      <Link to="/contact-us" className="nav-link">
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </nav>
              </>
            ) : (
              <a
                onClick={toggleMenu}
                className="meanmenu-reveal "
                style={{
                  right: 0,
                  left: "auto",
                  textAlign: "center",
                  textIndent: 0,
                  fontSize: "18px",
                }}
              >
                <span>
                  <span>
                    <span></span>
                  </span>
                </span>
              </a>
            )}
          </div>

          {/* Logo */}
          <a href="/" className="logo">
            <img src={imglogo} className="logo-one" alt="ITDOSE" loading="lazy" />
            <img src={imglogo} className="logo-two" alt="ITDOSE" loading="lazy" />
          </a>
        </div>
      </div>
    </>
  );
};

export default Navbar;
